import * as React from 'react';
import {connect} from 'react-redux';

import {convertToArray} from 'nutshell-core/filter';

import {colors} from 'shells/colors/colors';
import {Divider} from 'shells/layout/divider';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';

import {
    GAP_SELECT_VALUES_DAY_TO_YEAR,
    getReportDateRanges,
} from '../../../reports/report-constants';
import {ReportDateRangePickerSimple} from '../../../reports/report-date-range-picker-simple';
import type {ReportURLParams} from '../../../reports/report-types';

import * as actions from '../report/analytics-actions';

import {AnalyticsReportChart} from './analytics-report-chart';
import {AnalyticsReportDataSummary} from './analytics-report-data-summary';
import type {SiteAnalyticsChartParams} from './analytics-utils';

import styles from './analytics-report.module.css';

type OwnProps = {
    onParamChange: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    lastDetectedVisitTime: number | null | undefined;
};

type DispatchProps = {
    fetchReportData: (arg1: SiteAnalyticsChartParams, arg2: any[]) => any;
};

type Props = OwnProps & DispatchProps;

// @ts-expect-error
function mapDispatchToProps(dispatch) {
    return {
        // @ts-expect-error
        fetchReportData: (reportParams, filters) => {
            dispatch(actions.requestSiteAnalyticsReportData({reportParams, filters}));
        },
    };
}

function SiteAnalyticsReportComponent(props: Props) {
    const {period} = props.urlParams.filter;
    const {gap} = props.urlParams.report;

    React.useEffect(() => {
        const newFilter = convertToArray(props.urlParams.filter || {});

        props.fetchReportData(props.urlParams.report, newFilter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        const newFilter = convertToArray(props.urlParams.filter || {});
        props.fetchReportData(props.urlParams.report, newFilter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [period, gap]);

    const reportParams = props.urlParams.report || {};
    const currentGapIndex = GAP_SELECT_VALUES_DAY_TO_YEAR.findIndex((g) => {
        return g.id === reportParams.gap;
    });

    return (
        <div id='analytics-report' className={styles['analytics-report']}>
            <div id='scroll-container'>
                <div className={styles.top}>
                    <div className={styles.info}>
                        <span className='flex'>
                            Last visit&nbsp;
                            <RelativeTimestamp datetime={props.lastDetectedVisitTime} />
                        </span>
                        <Divider variant='dot' spacing={4} color={colors.grey} />
                        This chart is updated nightly at 3am EST
                    </div>
                    <div className={styles['period-picker']}>
                        <ReportDateRangePickerSimple
                            activeFilters={convertToArray(props.urlParams.filter)}
                            dateRangeType='period'
                            // @ts-expect-error
                            dateRangeOptions={getReportDateRanges('siteAnalytics')}
                            onDateRangeChange={(newFilter) => {
                                props.onParamChange(
                                    {filter: {...props.urlParams.filter, ...newFilter}},
                                    true
                                );
                            }}
                        />
                    </div>
                </div>
                <div className={styles['analytics-report']}>
                    <AnalyticsReportChart
                        activeFilters={convertToArray(props.urlParams.filter)}
                        reportDataSummary={
                            <AnalyticsReportDataSummary
                                currentGapIndex={currentGapIndex}
                                reportParams={reportParams}
                            />
                        }
                        height={400}
                        containerHeight={500}
                        onParamChange={props.onParamChange}
                        reportParams={reportParams}
                    />
                </div>
            </div>
        </div>
    );
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(null, mapDispatchToProps);
export const SiteAnalyticsReport = connector(SiteAnalyticsReportComponent);
